
import './App.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { AppTheme } from './theme';
import { ToastContainer } from 'react-toastify';
import { Provider, shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppActions, AppStore } from './store/store';
import 'react-toastify/dist/ReactToastify.css';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import React, { Suspense, useEffect } from 'react';
import { Helmet } from 'react-helmet';



const SigninPage = React.lazy(() => import('./pages/signin/signin'));
const SignupPage = React.lazy(() => import('./pages/signup/signup'));
const AccountPage = React.lazy(() => import('./pages/account/account'));
const VerifyAccountPage = React.lazy(() => import('./pages/verify-account/verify-account'));
const DashboardPage = React.lazy(() => import('./pages/dashboard/dashboard'));
const HomeListPage = React.lazy(() => import('./pages/homeList/homeList'));
const ImportPage = React.lazy(() => import('./pages/import/import'));
const HomePage = React.lazy(() => import('./pages/home/home'));
const SubscriptionPage = React.lazy(() => import('./pages/subscription/subscription'));
const PartnerLocatorPage = React.lazy(() => import('./pages/partner/calei_professional'));


function App() {


  useEffect(() => {
    try {
      TimeAgo.addDefaultLocale(en);
    } catch (e) { }
  }, [])

  return (
    <Provider store={AppStore}>
      <Helmet>
        <title>CaleiVent | Multi Family</title>
        <script async
          src="https://maps.googleapis.com/maps/api/js?key=AIzaSyD4Vwv6UU5aa69vwMF1j8cKzxBkYEFjIug&loading=async">
        </script>
      </Helmet>
      <ThemeProvider theme={AppTheme}>
        <CssBaseline></CssBaseline>
        <ToastContainer />
        <BrowserRouter>
          <AppRouter></AppRouter>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}


function AppRouter() {
  const dispatch = useDispatch();

  const { userId, isVerified, isInitialized } = useSelector((state) => {
    const auth = state?.auth;
    return {
      userId: auth?.user?._id,
      isVerified: auth?.user?.isVerified,
      isInitialized: auth?.isInitialized || false,
    };
  }, shallowEqual);

  useEffect(() => {
    dispatch(AppActions.auth.load({}));
  }, [dispatch, userId]);

  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: 'var(--page-background)' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  const RootRedirect = () => {
    if (!userId) return <Navigate to="/signin" replace />;
    if (isVerified === false) return <Navigate to="/verify-account" replace />;
    return <Navigate to="/dashboard/home-list" replace />;
  };

  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      {!userId ? (
        <>
          <Route path="/signin" element={<Suspense><SigninPage /></Suspense>} />
          <Route path="/signup" element={<Suspense><SignupPage /></Suspense>} />
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </>
      ) : (
        <>
          <Route path="/dashboard" element={<Suspense><DashboardPage /></Suspense>}>
            <Route index element={<Navigate to="home-list" replace />} />
            <Route path="home-list" element={<Suspense><HomeListPage /></Suspense>} />
            <Route path="home/:homeId" element={<Suspense><HomePage /></Suspense>} />
            <Route path="account" element={<Suspense><AccountPage /></Suspense>} />
            <Route path="subscription" element={<Suspense><SubscriptionPage /></Suspense>} />
            <Route path="calei-professional" element={<Suspense><PartnerLocatorPage /></Suspense>} />
            <Route path="import" element={<Suspense><ImportPage /></Suspense>} />
          </Route>

          {isVerified === false && (
            <Route path="/verify-account" element={<VerifyAccountPage />} />
          )}

          <Route path="*" element={<Navigate to="/dashboard/home-list" replace />} />
        </>
      )}
    </Routes>
  );
}


export { App };